import React, { useState } from 'react'
import { StyleSheet, View, Text } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { BottomModalBase, Button, } from '../../../../components/molecules'
import { TitleCategory } from '../../../../screens/menu/categories/AddCategory'
import { useCreateHashtag } from '@hooks'
import { useLanguage } from '@context'

export const AddHashtagModal = ({
  isVisible,
  setIsVisible
}: {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const styles = getStyle(theme)
  const [title, setTitle] = useState<string>('');

  const { mutate: addHashtag } = useCreateHashtag();


  const handleSave = () => {
    addHashtag({name: '#' + title.trim().replace('#', ''), contactAccountIds: []})
    setTitle('')
    setIsVisible(false)
  }

  return (
    <BottomModalBase isVisible={isVisible} setIsVisible={setIsVisible} largePaddingTop={false} hasCloseButton>
      <View style={styles.container}>  
        <Text style={styles.title}>{t('addHashtagModal.title')}</Text>
        <TitleCategory title={title} setTitle={setTitle} placeholder="#hashtag..." />
        <Button
          title={t('addHashtagModal.save')}
          onPress={handleSave}
          unfilled={false}
        />
      </View>
    </BottomModalBase>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      width: '100%',
      paddingBottom: theme.spacing.xl,
      paddingHorizontal: theme.spacing.xl,
      paddingTop: theme.spacing.lg,
    },
    title: {
      color: theme.colors.text,
      fontSize: theme.fontSize.large,
      fontWeight: 'bold',
      paddingBottom: theme.spacing.xl,
    },
    sectionTitle: {
      fontSize: theme.fontSize.extraSmall,
      color: theme.colors.greyBlue,
      fontWeight: '400',
      paddingTop: theme.spacing.lg,
      paddingBottom: theme.spacing.xs,
    },
    categoriesList: {
    },
    categoryItem: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: 'transparent',
      paddingVertical: theme.spacing.md,
      borderBottomWidth: 0.5,
      borderBottomColor: theme.colors.grey,
    },
    categoryContent: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    categoryIcon: {
      width: 50,
      height: 50,
      borderRadius: 25,
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: theme.spacing.lg,
    },
    categoryInfo: {
      flex: 1,
    },
    categoryName: {
      fontSize: theme.fontSize.large,
      fontWeight: '600',
      color: theme.colors.text,
      marginBottom: theme.spacing.xs,
    },
    categorySubtitle: {
      fontSize: theme.fontSize.medium,
      color: theme.colors.greyBlue,
      fontWeight: '400',
    },
  }) 